import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Skeleton } from 'antd'
import { inject } from 'mobx-react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const GET_OFFICER = gql`
    query barangayOfficerByUid(
		$officer_uid: String
	) {
		barangayOfficerByUid(
			officer_uid: $officer_uid
		)
    }
`

const OfficerName = (props) => {
	const { 
		AuthStore, officer_uid, ...rest 
	} = props
	// const [isSaving, setSaving] = useState(false)

	return (
		<Query query={GET_OFFICER} variables={{ officer_uid }}>
			{({ loading, error, data }) => {
				if (loading) return <Skeleton active/>
				const mOfficer = _.has(data, 'barangayOfficerByUid') ? data.barangayOfficerByUid : {}
				return <span { ...rest }>{mOfficer.full_name}</span>
			}}
		</Query>
	)
}

const composed = compose(
	inject('AuthStore')
)

export default composed(OfficerName)